<script setup lang="ts">

import {onBeforeMount, onMounted, watch} from "vue";
import {enumToNavigator, Language} from "@/constants/language";
import {useLanguageStore} from "@/stores/language-store";
import {useI18n} from "vue-i18n";
import {appTitleShort, useNavigationStore} from "@/stores/navigation-store";
import { useMessageHandler } from '@/helpers/error/useMessageHandler';

const i18n = useI18n();
const languageStore = useLanguageStore();
const navigationStore = useNavigationStore();
const errorMessageHandler = useMessageHandler();


onBeforeMount(async () => {
  errorMessageHandler.i18n = i18n;
  //If user is not logged in try to load the previous language from the cookie
  const languageString = enumToNavigator(languageStore.currentLang);
  //Set ui language to whats saved in browser cache
  if (i18n.locale.value != languageString) {
    i18n.locale.value = languageString;
  }

  languageStore.setLocale(languageStore.currentLang);

  //Load messages dynamically
  for (const lang of Object.keys(Language).filter((item) => {
    return isNaN(Number(item));
  })) {
    import(`@/assets/i18n/${lang}.json`).then(result => {
      const currentLanguage = Language[lang as keyof typeof Language];

      i18n.setLocaleMessage(enumToNavigator(currentLanguage), result.default);
    });
  }
})

onMounted(async () => {
  formatAppTitle();
})

watch(() => navigationStore.currentPageTranslationLabel, async (_) => {
  formatAppTitle();
})

function formatAppTitle() {
  document.title = `${i18n.t(navigationStore.currentPageTranslationLabel)} - ${appTitleShort}`;
}
</script>

<template>

</template>

<style scoped lang="scss">

</style>
